var inlet = require('aem-libs/src/initInlet.js').initInlet(
  'AemBranchesAppointments',
  /* global WEBPACK_INLET_VERSION */ WEBPACK_INLET_VERSION
)
var angular = require('angular')
require('angular-route')
require('angular-sanitize')
var widgetParamsService = require('aem-libs-angularjs/src/services/widgetParams.service.js').widgetParamsService
var placesOpeningHoursService = require('aem-libs-places-angularjs/src/services/places-opening-hours.service.js').placesOpeningHoursService
require('aem-libs-angularjs/src/filters/capitalize-formatter.filter.js')
require('aem-libs-angularjs/src/filters/phone-formatter.filter.js')
require('aem-libs-angularjs/src/components/tips-rotator/tips-rotator.component.js')
require('aem-libs-angularjs/src/components/backend-error/backend-error.component.js')
var dropdown = require('angular-ui-bootstrap/src/dropdown')
var appointmentsTrackingDataservice = require('aem-libs-places-angularjs/src/services/appointments-tracking.dataservice').appointmentsTrackingDataservice

angular.module('AemBranchesAppointments', ['ngRoute', 'ngSanitize', dropdown,
  'capitalizeFormatterCmp', 'phoneFormatterCmp', 'TipsRotatorCmp', 'BackEndErrorComp'])
  .factory('widgetParamsService', widgetParamsService)
  .factory('placesOpeningHoursService', placesOpeningHoursService)
  .factory('appointmentsTrackingDataservice', appointmentsTrackingDataservice)

  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when('/', {
        template: '<appointment-error></appointment-error>'
      })
      .when('/branch/:branchId', {
        template: '<appointment-select></appointment-select>',
        reloadOnSearch: false
      })
      .when('/branch/:branchId/timeslot/:timeslot', {
        template: '<appointment-create></appointment-create>'
      })
      .when('/appointment/:appointmentId', {
        template: '<appointment-detail></appointment-detail>'
      })
      .when('/cancel/:appointmentId', {
        template: '<appointment-cancel></appointment-cancel>'
      })
      .otherwise({
        redirectTo: '/'
      })
  }])

require('./inlet.css')
require('./inlet.controller.js')

require('aem-libs-angularjs/src/bootstrap').bootstrap({
  element: inlet.element,
  appName: 'AemBranchesAppointments',
  mainCtrlName: 'aemBranchesAppointmentsCtrl',
  basePath: inlet.basePath,
  config: /* global WEBPACK_INLET_CONFIG */ WEBPACK_INLET_CONFIG,
  supportedLanguages: {
    cs: require('./i18n/cs.js').cs,
    en: require('./i18n/en.js').en
  },
  html: require('./inlet.html')
})
